// ./context/student/studentReducer.js

const studentReducer = (state, { type, payload }) => {
    switch (type) {
        case 'LOAD_STUDENTS':
        case 'SET_STUDENT_DATA':
            return {
                ...state,
                studentData: payload,
                isLoading: false,
                error: null
            };

        case 'UPDATE_STUDENT_PROFILE':
            return {
                ...state,
                studentData: {
                    ...state.studentData,
                    ...payload
                },
                isLoading: false,
                error: null
            };

        case 'SET_ENROLLED_COURSES':
            return {
                ...state,
                enrolledCourses: payload,
                isLoading: false,
                error: null
            };

        case 'SET_COMPLETED_COURSES':
            return {
                ...state,
                completedCourses: payload,
                isLoading: false,
                error: null
            };

        case 'ENROLL_COURSE':
            return {
                ...state,
                enrolledCourses: [...state.enrolledCourses, payload],
                isLoading: false,
                error: null
            };

        case 'UNENROLL_COURSE':
            return {
                ...state,
                enrolledCourses: state.enrolledCourses.filter(
                    course => course.courseId !== payload
                ),
                isLoading: false,
                error: null
            };

        case 'UPDATE_COURSE_PROGRESS':
            return {
                ...state,
                enrolledCourses: state.enrolledCourses.map(course =>
                    course.courseId === payload.courseId
                        ? { ...course, progress: payload.progress }
                        : course
                ),
                isLoading: false,
                error: null
            };

        case 'SET_LAB_SUBMISSIONS':
            return {
                ...state,
                labSubmissions: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_LAB_SUBMISSION':
            return {
                ...state,
                labSubmissions: [...state.labSubmissions, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_LAB_SUBMISSION':
            return {
                ...state,
                labSubmissions: state.labSubmissions.map(lab =>
                    lab.labId === payload.labId && lab.courseId === payload.courseId
                        ? { ...lab, ...payload }
                        : lab
                ),
                isLoading: false,
                error: null
            };

        case 'SET_QUIZ_SUBMISSIONS':
            return {
                ...state,
                quizSubmissions: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_QUIZ_SUBMISSION':
            return {
                ...state,
                quizSubmissions: [...state.quizSubmissions, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_QUIZ_SUBMISSION':
            return {
                ...state,
                quizSubmissions: state.quizSubmissions.map(quiz =>
                    quiz.quizId === payload.quizId && quiz.courseId === payload.courseId
                        ? { ...quiz, ...payload }
                        : quiz
                ),
                isLoading: false,
                error: null
            };

        case 'SET_EXAM_SUBMISSIONS':
            return {
                ...state,
                examSubmissions: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_EXAM_SUBMISSION':
            return {
                ...state,
                examSubmissions: [...state.examSubmissions, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_EXAM_SUBMISSION':
            return {
                ...state,
                examSubmissions: state.examSubmissions.map(exam =>
                    exam.examId === payload.examId && exam.courseId === payload.courseId
                        ? { ...exam, ...payload }
                        : exam
                ),
                isLoading: false,
                error: null
            };

        case 'SET_CAPSTONE_SUBMISSIONS':
            return {
                ...state,
                capstoneSubmissions: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_CAPSTONE_SUBMISSION':
            return {
                ...state,
                capstoneSubmissions: [...state.capstoneSubmissions, payload],
                isLoading: false,
                error: null
            };

        case 'UPDATE_CAPSTONE_SUBMISSION':
            return {
                ...state,
                capstoneSubmissions: state.capstoneSubmissions.map(capstone =>
                    capstone.capstoneId === payload.capstoneId && capstone.courseId === payload.courseId
                        ? { ...capstone, ...payload }
                        : capstone
                ),
                isLoading: false,
                error: null
            };

        case 'SET_ACHIEVEMENTS':
            return {
                ...state,
                achievements: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_ACHIEVEMENT':
            return {
                ...state,
                achievements: [...state.achievements, payload],
                isLoading: false,
                error: null
            };

        case 'SET_NOTIFICATIONS':
            return {
                ...state,
                notifications: payload,
                isLoading: false,
                error: null
            };

        case 'MARK_NOTIFICATION_READ':
            return {
                ...state,
                notifications: state.notifications.map(notif =>
                    notif.notificationId === payload
                        ? { ...notif, isRead: true }
                        : notif
                ),
                isLoading: false,
                error: null
            };

        case 'SET_LEARNING_PATH':
            return {
                ...state,
                learningPath: payload,
                isLoading: false,
                error: null
            };

        case 'SET_LAB_PROGRESS':
            return {
                ...state,
                labProgress: payload,
                isLoading: false,
                error: null
            };

        case 'SET_QUIZ_PROGRESS':
            return {
                ...state,
                quizProgress: payload,
                isLoading: false,
                error: null
            };

        case 'SET_EXAM_PROGRESS':
            return {
                ...state,
                examProgress: payload,
                isLoading: false,
                error: null
            };

        case 'SET_CAPSTONE_PROGRESS':
            return {
                ...state,
                capstoneProgress: payload,
                isLoading: false,
                error: null
            };

        case 'SET_COURSE_GRADE':
            return {
                ...state,
                courseGrade: payload,
                isLoading: false,
                error: null
            };

        case 'SET_ALL_GRADES':
            return {
                ...state,
                allGrades: payload,
                isLoading: false,
                error: null
            };

        case 'CALCULATE_GRADE':
            return {
                ...state,
                calculatedGrade: payload,
                isLoading: false,
                error: null
            };

        case 'SET_COURSE_PROGRESS':
            return {
                ...state,
                courseProgress: payload,
                isLoading: false,
                error: null
            };

        case 'SET_CART':
            return {
                ...state,
                cart: payload.items || [],  // Extract items from cart data object
                isLoading: false,
                error: null
            };

        case 'ADD_TO_CART':
            return {
                ...state,
                cart: payload.cart || [],  // Extract cart from student object
                isLoading: false,
                error: null
            };

        case 'REMOVE_FROM_CART':
            return {
                ...state,
                cart: (state.cart || []).filter(item => item.courseId !== payload),
                isLoading: false,
                error: null
            };

        case 'CLEAR_CART':
            return {
                ...state,
                cart: [],
                isLoading: false,
                error: null
            };

        case 'SET_PAYMENT_HISTORY':
            return {
                ...state,
                paymentHistory: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_PAYMENT':
            return {
                ...state,
                paymentHistory: [payload, ...(state.paymentHistory || [])],
                isLoading: false,
                error: null
            };

        case 'PROCESS_PAYMENT':
            return {
                ...state,
                lastPayment: payload,
                isLoading: false,
                error: null
            };

        case 'SET_LOADING':
            return {
                ...state,
                isLoading: payload
            };

        case 'SET_ERROR':
            return {
                ...state,
                error: payload,
                isLoading: false
            };

        case 'CLEAR_STUDENT_DATA':
            return {
                studentData: null,
                enrolledCourses: [],
                completedCourses: [],
                labSubmissions: [],
                quizSubmissions: [],
                examSubmissions: [],
                capstoneSubmissions: [],
                achievements: [],
                notifications: [],
                learningPath: null,
                labProgress: null,
                quizProgress: null,
                examProgress: null,
                capstoneProgress: null,
                courseGrade: null,
                allGrades: [],
                calculatedGrade: null,
                courseProgress: null,
                cart: [],
                paymentHistory: [],
                lastPayment: null,
                isLoading: false,
                error: null
            };

        default:
            return state;
    }
};

export default studentReducer;